import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { reaction } from "mobx";
import "../assets/stylesheets/Eboard.scss";
import List from "../components/List";
import loadingImg from "../assets/images/loading-white.svg";
import Device from "../utils/Device";
import Alert from "../components/Alert";
import Buttons from "../components/Buttons";
import Infos from "../components/Infos";
import ProductStore from "../stores/ProductStore";

@inject("Navigator", "DropboxStore", "ConfigStore", "SchoolStore")
@observer
export default class Eboard extends Component {
  static get service() {
    return ProductStore.selectedProduct === 'TEENS'
        ? '/Teacher_Desk_Conquer_Teens/Materiais'
        : '/Teacher_desk/Materiais';
  }

  // --------------------------------------------------------------------------
  // STATE (somente o que o Alert precisa)
  // --------------------------------------------------------------------------
  state = {
    showAlert: false,
    message: "",
    name: "",
    url: "",
    id: "",
    canDelete: false,
  };

  // --------------------------------------------------------------------------
  // CICLO DE VIDA
  // --------------------------------------------------------------------------
  componentDidMount() {
    /* zera controles usados no breadcrumb */
    this.props.DropboxStore.breadcrumb = [];
    this.props.DropboxStore.names = [];
    this.props.DropboxStore.items = [];

    /* busca a pasta raiz e monta breadcrumb inicial */
    const pathDefault = Eboard.service;
    this.searchFolder(pathDefault);
    this.handleBreadCrumb(pathDefault, "");

    this._productDisposer = reaction(
      () => ProductStore.selectedProduct,
      () => {
        this.props.DropboxStore.breadcrumb = [];
        this.props.DropboxStore.names = [];
        this.props.DropboxStore.items = [];
        this.searchFolder(Eboard.service);
        this.handleBreadCrumb(Eboard.service, "");
      }
    );

    /* listeners de download / delete */
    document.addEventListener(
      "registerDownloadCompleted",
      this.checkFileStatus
    );
    document.addEventListener(
      "registerDeleteCompleted",
      this.checkFileStatusDeleted
    );
    document.addEventListener("showDownloadProgress", this.downloadProgress);
    document.addEventListener("notifiesFileExist", this.showFileExist);
    document.addEventListener("downloadBroken", this.downloadBroken);
  }

  componentWillUnmount() {
    if (this._productDisposer) this._productDisposer();
    document.removeEventListener(
      "registerDownloadCompleted",
      this.checkFileStatus
    );
    document.removeEventListener(
      "registerDeleteCompleted",
      this.checkFileStatusDeleted
    );
    document.removeEventListener("showDownloadProgress", this.downloadProgress);
    document.removeEventListener("notifiesFileExist", this.showFileExist);
    document.removeEventListener("downloadBroken", this.downloadBroken);
  }

  // --------------------------------------------------------------------------
  // NAVEGAÇÃO NAS PASTAS
  // --------------------------------------------------------------------------
  /** faz a busca no Dropbox */
    searchFolder(path) {
        this.props.DropboxStore.doSearchFolder(path);
    }

  /** clique em pasta */
  handleClickList = (url, name = "", clear = false) => {
    this.props.DropboxStore.breadcrumb = [];
    this.searchFolder(url);
    this.handleBreadCrumb(url, name, clear);
  };

  /** constrói / atualiza breadcrumb (mesma lógica do Library) */
  handleBreadCrumb = (url, name, clear) => {
    const clearUrl = url.replace(Eboard.service, "");
    if (clearUrl === "") return;

    /* limpa nomes anteriores quando volta para pai */
    if (clear) {
      const ind = this.props.DropboxStore.ind;
      const oldNames = [];
      for (let l = 0; l < ind; l++) oldNames[l] = this.props.DropboxStore.names[l];
      this.props.DropboxStore.names = oldNames;
    }

    const partes = clearUrl.split("/");
    this.props.DropboxStore.ind = partes.length - 2;

    const breadcrumb = this.props.DropboxStore.breadcrumb;
    const names = this.props.DropboxStore.names;

    if (name !== "") names[this.props.DropboxStore.ind] = name;

    for (let i = 0; i <= this.props.DropboxStore.ind; i++) {
      let path = Eboard.service;
      for (let j = 0; j <= i; j++) path += "/" + partes[j + 1];

      breadcrumb.push(
        <span key={i} className="tree">
          <a
            className="crumb"
            onClick={() => this.handleClickList(path, names[i], true)}
          >
            {names[i]}
          </a>
        </span>
      );
    }
  };

  // --------------------------------------------------------------------------
  // DOWNLOAD / DELETE
  // --------------------------------------------------------------------------
  handleDownloadFile = (name, url, id, canDownload) => {
    if (!canDownload) {
      console.log("cannot download a file that already was downloaded");
      return;
    }

    this.props.DropboxStore.doSearchTemporaryLink(url).then(() => {
      const link = this.props.DropboxStore.link;
      if (!link) return;

      if (Device.isMobile()) {
        Device.requestDownloadFile(link, name, id, false);
      } else {
        document.getElementById("download").setAttribute("href", link);
        document.getElementById("download").click();
      }
    });
  };

  handleDeleteFile = (name, url, id, canDelete) => {
    if (!canDelete) {
      console.log("cannot delete a file that never was downloaded");
      return;
    }
    Device.requestDeleteFile(url, name, id);
  };

  // --------------------------------------------------------------------------
  // LISTENERS QUE ATUALIZAM FLAGS (iguais ao Library)
  // --------------------------------------------------------------------------
  checkFileStatus = (e) => {
    const items = this.props.DropboxStore.items;
    const item = items.find((f) => f.name === e.detail.filename);
    if (item) item.isDownloaded = true;
    this.forceUpdate();
  };

  downloadProgress = (e) => {
    const items = this.props.DropboxStore.items;
    const item = items.find((f) => f.name === e.detail.filename);
    if (item) item.downloadProgress = e.detail.progress;
    this.forceUpdate();
  };

  checkFileStatusDeleted = (e) => {
    const items = this.props.DropboxStore.items;
    const item = items.find((f) => f.name === e.detail.filename);
    if (item) {
      item.isDownloaded = false;
      item.downloadProgress = 0;
    }
    this.forceUpdate();
  };

  showFileExist = (e) => {
    const items = this.props.DropboxStore.items;
    const item = items.find((f) => f.name === e.detail.filename);
    if (item) {
      item.isDownloaded = true;
      item.downloadProgress = 100;
    }
    this.forceUpdate();
  };

  downloadBroken = (e) => {
    const items = this.props.DropboxStore.items;
    const item = items.find((f) => f.name === e.detail.filename);
    if (item) {
      item.isDownloaded = false;
      item.downloadProgress = 0;
    }
    this.forceUpdate();
  };

  // --------------------------------------------------------------------------
  // RENDERIZAÇÃO DA LISTA
  // --------------------------------------------------------------------------
  renderItems = (items) =>
    items.map((item, idx) => {
      /* mantém a mesma persistência do Library */
      let storageItem = null;
      if (localStorage.getItem("files-" + item.id))
        storageItem = JSON.parse(localStorage.getItem("files-" + item.id));

      const src = storageItem || item;

      return (
        <li key={idx} className="listItem">
          <Buttons
            hasAllButtons={Device.isMobile()}
            name={src.name}
            url={src.url}
            id={src.id}
            type={src.type}
            isDownloaded={src.isDownloaded}
            downloadProgress={src.downloadProgress}
            hasError={src.hasError}
            onClickDownload={this.handleDownloadFile}
            onClickDelete={this.handleDeleteFile}
            onClickPlay={() => this.handleOpenBook(src.name)}
            onClickFolder={() =>
              this.handleClickList(item.url, item.name, false)
            }
          />
          <div className="title-book">{item.name}</div>
          {item.type === "file" ? (
            <Infos
              hasAllInfos={Device.isMobile()}
              hasError={src.hasError}
              size={src.size}
              isDownloaded={src.isDownloaded}
            />
          ) : (
            <div />
          )}
        </li>
      );
    });

  // --------------------------------------------------------------------------
  // RENDER
  // --------------------------------------------------------------------------
  render() {
    const { isLoading, items, breadcrumb } = this.props.DropboxStore;

    if (isLoading) {
      return (
        <div className="Eboard Page">
          <div className="container">
            <div className="header-section">
              <h1>Materiais</h1>
              <p id="bread-crumb">
                <span className="first">Portal do professor</span>
                <span className="tree">
                  <a
                    className="crumb"
                    onClick={() => this.handleClickList(Eboard.service)}
                  >
                    Materiais
                  </a>
                </span>
              </p>
            </div>
            <div className="contents">
              <List>
                <li>
                  <img role="presentation" src={loadingImg} alt="loading" />
                </li>
              </List>
            </div>
          </div>
        </div>
      );
    }

    const list = this.renderItems(items);

    return (
      <div className="Eboard Page">
        <div className="container">
          <div className="header-section">
            <h1>Materiais</h1>
            <div className="Breadcrumb">
              <p id="bread-crumb">
                <span className="first">Portal do professor</span>
                <span className="tree">
                  <a
                    className="crumb"
                    onClick={() =>
                      this.handleClickList(Eboard.service, "Materiais")
                    }
                  >
                    Materiais
                  </a>
                </span>
                {breadcrumb}
              </p>
            </div>
          </div>
          <div className="mt-30" />
          <div className="contents">
            <List
              loader={isLoading}
              counter={list.length}
              messageEmpty="Não há materiais disponíveis."
            >
              {list}
            </List>
            <a id="download" href="" download />
            <a id="open-file" href="" />
          </div>
        </div>

        {/* ALERTA DE CONFIRMAÇÃO */}
        <Alert
          show={this.state.showAlert}
          message={this.state.message}
          onClick={() => this.setState({ showAlert: false })}
        />
      </div>
    );
  }

  // --------------------------------------------------------------------------
  // ABRIR PDF LOCAL
  // --------------------------------------------------------------------------
  handleOpenBook(filename) {
    if (Device.isMobile()) {
      Device.requestOpenReader(filename);
    } else {
      const path = "http://127.0.0.1:8887/" + filename;
      const openLink = document.getElementById("open-file");
      openLink.setAttribute("href", path);
      openLink.setAttribute("target", "_blank");
      openLink.click();
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Eboard.js